<template>
    <div class="container mt-5">

    <router-link class="btn-back" to="/"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page précédente</router-link>
    <div class="titleProduct"><img src="@/assets/img/fleet/FleetMain.png" alt=""></div>
    <div class="subTitle">{{ $t('fleetpage.title') }}</div>
    <!-- <video src="https://d2xwffv7hmia2n.cloudfront.net/images/content/references/video/fleet.mp4" autoplay controls></video> -->


    <div class="screenContainer">
        <img src="@/assets/img/fleet/dashboard.png" 
            class="img-fluid image dashboardScreen" 
            alt="Fleet Dashboard" 
            data-aos="zoom-out-left"
            data-aos-duration="700">
        <img src="@/assets/img/fleet/app.png" 
            class="img-fluid appScreen" 
            alt="Fleet App" 
            data-aos="zoom-out-right"
            data-aos-duration="1000">
    </div>

    <div class="mx-auto ">
        <div class="row bigRow">
            <div class="col">
                <div class="sectionTitle">
                    {{ $t('fleetpage.fast.title') }}
                </div>
            </div>
            <div class="col">
                <!-- <img src="@/assets/img/fleet/fleet1.gif" class="mx-auto " alt=""> -->
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/gaintime.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.fast.title1') }}
                        </div>
                        {{ $t('fleetpage.fast.content1') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/smartload.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.fast.title2') }}
                        </div>
                        {{ $t('fleetpage.fast.content2') }}
                    </div>
                </div>
            </div>
            <div class="col">
              <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/route.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.fast.title3') }}
                        </div>
                        {{ $t('fleetpage.fast.content3') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/success.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.fast.title4') }}
                        </div>
                        {{ $t('fleetpage.fast.content4') }}
                    </div>
                </div>
            </div>
        </div>
        
     
        <div class="row bigRow">
            <div class="col">
                <div class="sectionTitle">
                    {{ $t('fleetpage.cost.title') }}
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/documents.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.cost.title1') }}
                        </div>
                        {{ $t('fleetpage.cost.content1') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/quality.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.cost.title2') }}
                        </div>
                        {{ $t('fleetpage.cost.content2') }}
                    </div>
                </div>
            </div>
            <div class="col">
              <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/drop.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.cost.title3') }}
                        </div>
                        {{ $t('fleetpage.cost.content3') }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <img src="@/assets/img/fleet/danger.png" class="img-fluid" alt="">
                    </div>
                    <div class="col">
                        <div class="bolder">
                            {{ $t('fleetpage.cost.title4') }}
                        </div>
                        {{ $t('fleetpage.cost.content4') }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sectionBanner" data-aos="flip-up"  data-aos-duration="1000" >
        <div class="subTitle">{{ $t('fleetpage.bosection.title') }}</div>
        <img src="@/assets/img/fleet/operateur.jpg" class="img-fluid image" alt="DigitAppro">
    </div>

    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.bosection.flux.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col"  data-aos="zoom-in-right"  data-aos-duration="1000"><img src="@/assets/img/fleet/flux.png" class="img-fluid image" alt="DigitAppro"></div>
            <div class="col-md-6 p-5">
                <div class="bolder">
                    {{ $t('fleetpage.bosection.flux.subtitle1') }}
                </div>
                <p>{{ $t('fleetpage.bosection.flux.content1') }}</p>                
                <div class="bolder">
                    {{ $t('fleetpage.bosection.flux.subtitle2') }}
                </div>
                <p>{{ $t('fleetpage.bosection.flux.content2') }}</p> 
            </div>
        </div>
    </div>


    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.bosection.track.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col"  data-aos="zoom-in-right"  data-aos-duration="1000">
                <img src="@/assets/img/fleet/carte.png" class="img-fluid image" alt="DigitAppro">
            </div>
            <div class="col-md-6 p-5">
                <div class="bolder">
                    {{ $t('fleetpage.bosection.track.subtitle') }}
                </div>
                <p> {{ $t('fleetpage.bosection.track.content1') }}</p>
                <p> {{ $t('fleetpage.bosection.track.content2') }}</p> 
            </div>
        </div>
    </div>

    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.bosection.time.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col"  data-aos="zoom-in-right"  data-aos-duration="1000">
                <img src="@/assets/img/fleet/reclamations.png" class="img-fluid image" alt="DigitAppro">
            </div>
            <div class="col-md-8 p-5">
                <div class="bolder">
                    {{ $t('fleetpage.bosection.time.subtitle') }}
                </div>
                <p>{{ $t('fleetpage.bosection.time.content') }}</p>
                <p><strong>{{ $t('fleetpage.bosection.time.contentbold') }}</strong></p>                
            </div>
        </div>
    </div>

    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.bosection.proof.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col"  data-aos="zoom-in-right"  data-aos-duration="1000">
                <img src="@/assets/img/fleet/menu.png" class="img-fluid  mb-2" alt="DigitAppro">
                <img src="@/assets/img/fleet/photo.png" class="img-fluid image" alt="DigitAppro">
            </div>
            <div class="col-md-6 p-5">
                <div class="bolder">
                    {{ $t('fleetpage.bosection.proof.subtitle') }}
                </div>
                <p> {{ $t('fleetpage.bosection.proof.content1') }} </p>   

                <ul>

                    <li><strong>{{ $t('fleetpage.bosection.proof.boldline1') }}</strong> </li>
                    <p>{{ $t('fleetpage.bosection.proof.content2') }}
                        <ul>
                            <li>{{ $t('fleetpage.bosection.proof.line1') }}</li>
                            <li>{{ $t('fleetpage.bosection.proof.line2') }}</li>
                            <li>{{ $t('fleetpage.bosection.proof.line3') }}</li>
                            <li>{{ $t('fleetpage.bosection.proof.line4') }}</li>
                        </ul>
                    </p>

                    <li><strong>{{ $t('fleetpage.bosection.proof.boldline2') }}</strong> </li>
                    <p>{{ $t('fleetpage.bosection.proof.content3') }}
                        <ul>
                            <li>{{ $t('fleetpage.bosection.proof.line5') }}</li>
                            <li>{{ $t('fleetpage.bosection.proof.line6') }}</li>
                        </ul>
                    </p>

                </ul>

            </div>
        </div>
    </div>

    <div class="sectionBanner" data-aos="flip-up"  data-aos-duration="1000" >
        <div class="subTitle">{{ $t('fleetpage.driverSection.title') }}</div>
        <img src="@/assets/img/fleet/livreur.jpg" class="img-fluid image" alt="DigitAppro">
    </div>


    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.driverSection.absence.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 pr-5">
                <div class="bolder">
                    {{ $t('fleetpage.driverSection.absence.subtitle') }}
                </div>
                <p>{{ $t('fleetpage.driverSection.absence.content1') }}</p>
                <p>{{ $t('fleetpage.driverSection.absence.content2') }} </p><p> <strong>{{ $t('fleetpage.driverSection.absence.contentbold') }}</strong></p>                
            </div>
            <div class="col flat-box"  data-aos="zoom-in-right"  data-aos-duration="1000">
               <img src="@/assets/img/fleet/photoproof.png" class="img-fluid flat rounded mb-2" alt="Application Fleet">
            </div>
        </div>
    </div>

    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.driverSection.offline.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 pr-5">
                <div class="bolder">
                    {{ $t('fleetpage.driverSection.offline.subtitle') }}
                </div>
                <p>{{ $t('fleetpage.driverSection.offline.content') }}</p>
            </div>
            <div class="col flat-box"  data-aos="zoom-in-right"  data-aos-duration="1000">
               <img src="@/assets/img/fleet/nosignal.png" class="img-fluid flat rounded mb-2" alt="Application Fleet">
            </div>
        </div>
    </div>


    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.driverSection.simple.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 pr-5">
                <div class="bolder">
                    {{ $t('fleetpage.driverSection.simple.subtitle') }}
                </div>
                <p>{{ $t('fleetpage.driverSection.simple.content1') }} </p>
                <p>{{ $t('fleetpage.driverSection.simple.content2') }}</p>
            </div>
            <div class="col flat-box"  data-aos="zoom-in-left"  data-aos-duration="1000">
                <img src="@/assets/img/fleet/chauffeur.png" class="img-fluid flat rounded mb-2" alt="Application Fleet">
            </div>
        </div>
    </div>

    
    <div class="row bigRow">
        <div class="sectionTitle"> 
            {{ $t('fleetpage.driverSection.co2.title') }}
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 pr-5">
                <div class="bolder">
                    {{ $t('fleetpage.driverSection.co2.subtitle') }}
                </div>
                <p>
                    <ul>
                        <li><strong>{{ $t('fleetpage.driverSection.co2.boldline1') }} </strong> {{ $t('fleetpage.driverSection.co2.line1') }}</li>
                        <li><strong>{{ $t('fleetpage.driverSection.co2.boldline2') }} </strong> {{ $t('fleetpage.driverSection.co2.line2') }}</li>
                        <li><strong>{{ $t('fleetpage.driverSection.co2.boldline3') }} </strong> {{ $t('fleetpage.driverSection.co2.line3') }}</li>
                    </ul>
                </p>
            </div>
            <div class="col flat-box"  data-aos="zoom-in-right"  data-aos-duration="1000">
                <img src="@/assets/img/fleet/farmer.svg" class="img-fluid flat mb-2" alt="Application Fleet">
            </div>
        </div>
    </div>


    <div class="sectionBanner" >
        <div class="subTitle">{{ $t('fleetpage.priceSection.title') }}</div>
        {{ $t('fleetpage.priceSection.subtitle1') }} <strong>{{ $t('fleetpage.priceSection.subtitle2') }}</strong> {{ $t('fleetpage.priceSection.subtitle3') }} <br> {{ $t('fleetpage.priceSection.subtitle4') }} <strong>{{ $t('fleetpage.priceSection.subtitle5') }}</strong> {{ $t('fleetpage.priceSection.subtitle6') }}
    </div>



    <div class="row my-5">
        <div class="col">
            <div class="btnPrice" v-bind:class="{ active: option == 'livraison' }" v-on:click="selectOption('livraison')">
                <i class="fas fa-mobile btnIcon"></i>
                <div>
                    <div class="bolder">{{ $t('fleetpage.priceSection.delivery') }}</div>
                    <div class="text">{{ $t('fleetpage.priceSection.deliverytext') }}</div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="btnPrice" v-bind:class="{ active: option == 'optimisation' }"  v-on:click="selectOption('optimisation')">
                <i class="fas fa-route btnIcon"></i>
                <div>
                    <div class="bolder">{{ $t('fleetpage.priceSection.optimization') }}</div>
                    <div class="text">{{ $t('fleetpage.priceSection.optimizationtext') }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="priceContainer">

   
        <div class="text-center mb-3">
            {{ $t('fleetpage.priceSection.selectTrucks') }}
        </div>
        <div class="text-center">
            <input type="range" class="rangePrice custom-range" min="1" max="50" step="1" v-model="truckCount" v-on:change='selectOption(option)' id="truckCount">
        </div>
        


        <div class="row mt-4">
            <div class="col">
                <label for="truckCount"> {{ $t('fleetpage.priceSection.pricefor') }} <span>{{truckCount}}</span> {{ $t('fleetpage.priceSection.truck') }}{{truckCount > 1 ? "s" : null}}</label>
                <ul class="list-unstyled">
                    <li><i class="fas fa-check listIcon"></i> {{ $t('fleetpage.priceSection.line1') }}</li>
                    <li><i class="fas fa-check listIcon"></i> {{ $t('fleetpage.priceSection.line2') }}</li>
                    <li><i class="fas fa-check listIcon"></i> {{ $t('fleetpage.priceSection.line3') }}</li>
                    <li><i class="fas fa-check listIcon"></i> {{ $t('fleetpage.priceSection.line4') }}</li>
                    <li><i class="fas fa-check listIcon"></i> {{ $t('fleetpage.priceSection.line5') }}</li>
                    <li v-show="option == 'optimisation'"><i class="fas fa-check listIcon bleu"></i> <strong>{{ $t('fleetpage.priceSection.line6') }}</strong></li>
                    <li v-show="option == 'optimisation'"><i class="fas fa-check listIcon bleu"></i> <strong>{{ $t('fleetpage.priceSection.line7') }}</strong></li>
                    <li v-show="option == 'optimisation'"><i class="fas fa-check listIcon bleu"></i> <strong>{{ $t('fleetpage.priceSection.line8') }}</strong></li>
                </ul>
            </div>
            <div class="col">
                <div class="priceBox">
                    <div class="unitPrice">
                        {{ $t('fleetpage.priceSection.sub') }} {{unitPrice}}€ ht / {{ $t('fleetpage.priceSection.truck') }} / {{ $t('fleetpage.priceSection.month') }}
                    </div>
                    <div class="totalPrice">
                        {{totalPrice}}€ <span class="monthly">/ {{ $t('fleetpage.priceSection.month') }}  </span>
                    </div>  
                    <div class="unitPrice">
                        {{ $t('fleetpage.priceSection.engage') }}
                    </div>     
                    <router-link class="btn btn-primary mt-5" to="/contact">{{ $t('fleetpage.priceSection.contact') }}</router-link>    
                </div>
            </div>
        </div>
    </div>

    
    <!-- <div class="row mt-5 pt-5">
        <div class="col-md-8">
            <p>Les enjeux liés à la livraison sont prédéterminants dans un processus de production. Dans le domaine agricole, 
                viticole ou tout autre secteur d’activité, il est important pour chaque client de savoir ou en est sa livraison, de planifier une disponibilité, 
                de valider du dépôt et de la bonne réception des marchandises, produits et articles attendus.</p>
            <p>De part et d’autre, que ce soit pour l’expéditeur comme pour le client, mais aussi pour assurer un meilleur service pour le livreur, 
                l’application Fleet permet de suivre, en temps réel, à chaque instant l’état d’avancement de la tournée, d’optimiser le circuit de livraison, 
                de données le maximum d’informations au livreur pour l’accès au lieu de livraison, de valider soit par signature soit avec photographies 
                le dépôt des marchandises si le client est absent, de suivre et faciliter les procédures internes à cette tâche. 
                Le mobile est l’outil de prédilection permettant la souplesse et le confort pour le livreur, mais aussi pour le client final.</p>

                <p class="highlighted">L’application Fleet a été mise en place pour Seveal en partenariat avec SAP. </p>
                
                <p>Les coûts pour une Coopérative ou un partenaire sont simples et transparents, à savoir un coût lié à l’interfaçage et un abonnement mensuel lié au nombre de véhicules</p>
        </div>
        <div class="col ">
            <img src="@/assets/img/fleet/fleetPhone.png" class="img-fluid ml-auto" alt="Fleet app">
        </div>
    </div> -->



    


    <div class="title">Clients</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/seveal.png" alt=""></div>
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/logo_novagrain.svg" alt="Logo Novagrain"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/logo_capvert.jpg" class="logoClient" alt="Logo Cap Vert"></div>
      <div class="col-lg-3 logoContainer"><img src="../assets/img/logo_talian.jpg" class="logoClient" alt="Logo Talian"></div>
    </div>
    <div class="title">{{ $t('fleetpage.partners') }}</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/partners/eliot.jpg" alt=""></div>
    </div>
    <div class="title">{{ $t('fleetpage.connectors') }}</div>
    <div class="row clients-logo text-center">
      <div class="col-lg-3 logoContainer"><img src="@/assets/img/sap.png" alt=""></div>
    </div>
    
    
    <div class="row mt-5 mb-5 text-center">
        <a class="btn btn-secondary-outline ml-auto" href="https://apps.apple.com/fr/app/fleet-agrivitech/id1523653744?l=fr" target="blank">{{ $t('fleetpage.discoBtn') }}</a>
        <router-link class="btn btn-primary mr-auto" to="/contact-demo"> {{ $t('fleetpage.demoBtn') }}</router-link>
    </div>

    <MailjetNewsLetter/>

  </div>
</template>

<script >
    import MailjetNewsLetter from '../components/MailjetNewsLetter'


    export default {
        name: 'Fleet',
        components:{
            MailjetNewsLetter
        },
        props:{
        },
        data(){
            return {
                option: 'livraison',
                livPrice: 25,
                optiPrice: 45,
                unitPrice: 25,
                totalPrice: 25,
                truckCount: 1
            }
        },   
        methods:{
            selectOption (option) {
               this.option = option

               if (this.truckCount > 19) {
                   this.livPrice = 20
                   this.optiPrice = 40
               } else {
                   this.livPrice = 25
                   this.optiPrice = 45
               }
               
                if (option == 'livraison') {
                    this.unitPrice = this.livPrice
                    this.totalPrice = this.livPrice * this.truckCount
                } else {
                    this.unitPrice = this.livPrice + this.optiPrice
                    this.totalPrice = ( this.livPrice + this.optiPrice ) * this.truckCount
                }
            }
        }
    }

    
</script>

<style lang="scss" scoped>


    .rangePrice{
        max-width: 500px;
    }
    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
        margin-top: -14px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d; /* Add cool effects to your sliders! */
    }

    .sectionTitle{
        color: var(--mainBlue);
        font-size: 28px;
        font-weight: 700;
        min-width: 300px;
        margin-bottom: 50px;
    }

    .sectionBanner{
        text-align: center;
        .subTitle{
            font-weight: 700!important;
        }
    }

    .priceContainer{
        padding: 40px;
        border-radius: 20px;
        border: 1px #f0f0f0 solid;
        background-color: #f9f9f9;
        -webkit-transition: all .1s ease-in-out;
        transition: all .1s ease-in-out;
        label{
            font-weight: 600;
            text-transform: uppercase;
            color: var(--mainFleet);
            margin-bottom: 20px;
            font-size: 22px;
            span{
                font-weight: 700;
                font-size: 26px;
            }
        }
        ul{
            margin-top: 20px;
        }
        li{
            padding: 10px 0px;
        }
        .listIcon{
            color: var(--mainFleet);
            margin-right: 10px;
            &.bleu{
                color: var(--mainGreen);
            }
        }
        .priceBox{
            padding: 40px;
            border-radius: 20px;
            border: 1px #f0f0f0 solid;
            background-color: white;
            height: auto;
            text-align: center;
            .unitPrice{
                text-transform: uppercase;
                font-size: 13px;
                font-weight: 600;
                color: #344b80;
            }
            .totalPrice{
                font-size: 30px;
                font-weight: 700;
                padding: 60px 0px;
                .monthly{
                    font-size: 16px;
                }
            }
            .btn{
                min-width: 200px;
                margin: 30px 0px  ;
            }
        }
    }

    .btnPrice{
        padding: 40px;
        border-radius: 20px;
        border: 1px #f0f0f0 solid;
        background-color: #f9f9f9;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        -webkit-transition: all .1s ease-in-out;
        transition: all .1s ease-in-out;
        &:hover{
            background-color: white;
            cursor: pointer;
            -webkit-transition: all .1s ease-in-out;
            transition: all .1s ease-in-out;
            .btnIcon{
                color: var(--mainFleet);
                -webkit-transition: all .1s ease-in-out;
                transition: all .1s ease-in-out;
            }
        }
        &.active{
            border-color: var(--mainFleet);
            background-color: white;
            .btnIcon{
                color: var(--mainFleet);
        }
        }
        .bolder{
                font-weight: 600;
                font-size: 18px;
                padding-bottom: 10px;
            }
        .btnIcon{
            color: grey;
            font-size: 30px;
            -webkit-transition: all .1s ease-in-out;
            transition: all .1s ease-in-out;
            margin: 10px;
        }
    }

    .bigRow{
        margin-top: 100px;
        margin-bottom: 100px;
        @media (max-width: 768px) {
           padding: 20px;
        }
        p{
            text-align: justify;
        }
        .row{
            margin-bottom: 50px;
            img{
                min-width: 40px;
            }
            .bolder{
                font-weight: 600;
                font-size: 18px;
                padding-bottom: 10px;
            }
        }
    }

    .logoClient {
    max-height: 80px;
  }

    .image{
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        border-radius: 10px;
    }

    .flat-box{
        display: flex;
        justify-content: center;
        .flat{
            max-width: 250px;
        }
    }
    
    video{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        &:hover{
            cursor:auto;
        }
    }

    .bulletPoint{
        text-align: center;
        font-size: 20px;
        padding: 5px;
    }

    .titleProduct{
        text-align: center;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
        margin-bottom: 50px;
    }
    .subTitle{
        text-align: center;
        font-weight: 700;
    }

    .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 300px;
    }


    
    .screenContainer{
        @media (max-width: 768px) {
            display: none;
        }
        position: relative;
        height: 800px;
        .dashboardScreen{
            position: absolute;
            // transform: translate(-5%, 0px)!important;
            top: 0;
            left: -5%;
        }
        .appScreen{
            position: absolute;
            right: -15%;
            max-height: 800px;
            // transform: translate(20%, 0px)!important;
            padding-left: 20%;
        }
    }

    @media (max-width: 768px) {
        .subTitle{
            font-size: 17px!important;
        }
    }


    .rounded{
        border-radius: 10px!important;
    }
    



</style>